import React, { useContext } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { AuthContext } from "../../../../../auth-context";
import AvatarLogo from "../../../../../images/theme/avatar/logo-horizontal-dark.png";
import FBBCLogo from "../../../../../images/theme/fbbc/fbbc-logo-dark.png";
import iconCheck from "../../../../../images/iconCheck.png";
import Modal from "../../../../../components/modal-fullscreen";
import styled from "styled-components";
import moment from "moment";
import { ThemeContext } from "styled-components";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  image: {
    width: 140,
  },
  sectionHeader: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    fontSize: 10,
    padding: 4,
    marginBottom: 8,
    fontWeight: 700,
    width: "50%",
    // fontFamily: "Oswald",
  },
  metadata: {
    fontSize: 10,
    padding: 4,
    marginBottom: 4,
    fontWeight: 700,
  },
  text: {
    color: "#444",
    fontSize: 12,
    marginTop: 12,
    // fontFamily: "Times-Roman",
  },
  spacer: {
    height: 16,
  },
  option: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 20,
    gap: 2,
  },
  circle: {
    border: "1px solid #555",
    width: 12,
    height: 12,
    borderRadius: "50%",
  },
  circleChecked: {
    width: 12,
    height: 12,
  },
  questionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 6,
  },
  questionDescription: {
    fontSize: 10,
    color: "#555",
    marginBottom: 6,
  },
  optionText: {
    fontSize: 12,
    color: "#555",
  },
  questionContainer: {
    marginBottom: 20,
  },
  responseText: {
    fontSize: 12,
  },
  noResponse: {
    fontSize: 12,
    fontStyle: "italic",
  },
});

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const mapLogos = {
  AVATAR: AvatarLogo,
  FBBC: FBBCLogo,
};

// Create Document Component
const SurveyPDF = ({ data = {}, name, theme }) => {
  const { survey_data, response_data } = data;

  const renderResponse = (question, response) => {
    switch (question.responseType) {
      case "text":
        return <Text style={styles.responseText}>{response.response}</Text>;
      case "multiple_choice":
      case "checkbox":
        const options = question?.options?.map((option) => {
          const isChecked = response?.response.includes(option.id);
          return (
            <View key={option.id} style={styles.option}>
              {isChecked ? (
                <Image
                  src={iconCheck}
                  alt="check"
                  style={styles.circleChecked}
                />
              ) : (
                <View style={styles.circle} />
              )}
              <Text style={styles.optionText}>{option.value}</Text>
            </View>
          );
        });
        return options;
      case "linear_scale":
        return <Text style={styles.responseText}>{response.response}</Text>;
      default:
        return null;
    }
  };

  return (
    <Document>
      <Page style={styles.body}>
        <Image style={styles.image} src={mapLogos[theme.name]} />
        <View style={styles.spacer} />
        <Text style={styles.sectionHeader}>SURVEY</Text>
        <Text style={styles.metadata}>Title: {survey_data?.title}</Text>
        <Text style={styles.metadata}>
          Description: {survey_data?.description}
        </Text>
        <Text style={styles.metadata}>
          Check-in Date: {moment.utc(data?.report_date).format("MMMM D, YYYY")}
        </Text>
        <Text style={styles.metadata}>
          Response Date: {moment.utc(data?.created_at).format("MMMM D, YYYY")}
        </Text>
        <Text style={styles.metadata}>Client: {name}</Text>
        <View style={styles.spacer} />
        <Text style={styles.sectionHeader}>RESPONSE</Text>
        {survey_data?.questions?.map((question, index) => {
          const response = response_data.find(
            (r) => r.question_id === question.id
          );
          return (
            <View key={question.id} style={styles.questionContainer}>
              <Text style={styles.questionTitle}>
                {index + 1}. {question.title}
              </Text>
              <Text style={styles.questionDescription}>
                {question.description}
              </Text>
              {response ? (
                renderResponse(question, response)
              ) : (
                <Text style={styles.noResponse}>No response</Text>
              )}
            </View>
          );
        })}
      </Page>
    </Document>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;

  iframe {
    border: none;
    flex: 1;
    height: 100%;
    width: 100%;
  }
`;

export const PreviewSurveyPDF = ({ open, handleClose, data = {} }) => {
  const theme = useContext(ThemeContext);
  const { user } = useContext(AuthContext);
  const currentAccount = user.accounts?.find(
    (account) => account.user_id === data?.user_id
  );

  return (
    <>
      <Modal
        hideAction
        // fullScreen
        // title={`Preview Invoice`}
        submitLabel={`Close`}
        open={open}
        onClose={() => handleClose(false)}
        // handleSubmit={handleSend}
      >
        <Container>
          <PDFViewer>
            <SurveyPDF data={data} name={currentAccount?.name} theme={theme} />
          </PDFViewer>
        </Container>
      </Modal>
    </>
  );
};
